<script lang="ts" setup>
import type { IProps } from './MultiuczynekItem.types'
defineProps<IProps>()
</script>

<template>
  <div class="multiuczynek-item">
    <div class="multiuczynek-item__top">
      <picture
        v-if="item.icon"
        class="multiuczynek-item__picture"
      >
        <source
          media="(width < 1200px)"
          :srcset="item.icon.urlMobile"
        >

        <source
          media="(width >= 1200px)"
          :srcset="item.icon.url"
        >

        <img
          class="multiuczynek-item__icon"
          :src="item.icon.url"
          :alt="item.icon.alternative"
        >
      </picture>
    </div>
    <div class="multiuczynek-item__content">
      <h3 class="multiuczynek-item__heading">
        {{ item.title }}
      </h3>

      <div
        class="multiuczynek-item__text"
        v-html="item.text"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.multiuczynek-item {
  display: flex;
  flex-direction: row;
  gap: 2.4rem;

  &__top {
    position: relative;
    flex: 1 0 7.2rem;
    margin-bottom: 4rem;
    text-align: center;
    border-top-left-radius: 1.6rem;
    border-top-right-radius: 1.6rem;
  }

  &__content {
    flex: 1 1 auto;
  }

  &__heading {
    @include h8;
    margin-bottom: 2.4rem;
    text-align: left;
  }

  &__text {
    @include body-1-medium;
    height: 100%;
    text-align: left;
  }

  @include atM {
    flex: 1;
    flex-direction: column;
    gap: 0;

    &__top {
      flex: 1;
      height: 17rem;
    }

    &__heading {
      @include h9;
      text-align: center;
    }

    &__text {
      text-align: center;
    }
  }
}
</style>
